import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';

interface Props {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

export default function ReportExportButton({ onClick, disabled, label }: Props) {
  const { t } = useTranslation();
  const exportLabel = label ?? t('reports.exportCsv');
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="bg-[#1fa8ff] hover:bg-[#0a8cd8] text-white border-0 shadow-sm shadow-[#1fa8ff]/30 font-medium text-sm py-2 px-4 rounded-lg flex items-center gap-2 disabled:opacity-50 shrink-0 transition-all"
    >
      <Download className="w-4 h-4" />
      {exportLabel}
    </button>
  );
}
